/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const PDFContainer = styled.div`
  width: 1000px;
  height: 1000px;

  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const HERO_PADDING_WITH_BREADCRUMBS = `
  padding-top: 138px;

  @media (max-width: 1450px) {
    padding-top: 128px;
  }

  @media (max-width: 1199px) {
    padding-top: 80px;
  }
`;

export const HERO_PADDING_WITHOUT_BREADCRUMBS = `
  padding-top: 192px;

  @media (max-width: 1450px) {
    padding-top: 182px;
  }

  @media (max-width: 1199px) {
    padding-top: 100px;
  }
`;
